
import * as net from "@ivanlog/net";
import {AuthService} from "./classes/AuthService";
import {DEXWatcher} from "./classes/DEXWatcher";
import {LPXWatcher} from "./classes/LPXWatcher";

export class UDexWatcherCoreAPI {
	private readonly _httpClient: net.HTTPClient;
	public authService: AuthService;
	public dEXWatcher: DEXWatcher;
	public lPXWatcher: LPXWatcher;
	/**
	* @param {string} url - baseUrl for api
	* @param {(e: unknown, args?: unknown) => void} errorsHandler? - errors handler for safe methods
	*/
	constructor (url: string, errorsHandler?: (e: unknown, args?: unknown) => void){
		this._httpClient = new net.HTTPClient(url);
		this.authService= new AuthService(this._httpClient, errorsHandler);
		this.dEXWatcher= new DEXWatcher(this._httpClient, errorsHandler);
		this.lPXWatcher= new LPXWatcher(this._httpClient, errorsHandler);
	}
	
	public getHTTPClient(): net.HTTPClient {
		return this._httpClient;
	}
}
